export default "__VITE_ASSET__54r3zxi4__";